import styled from 'styled-components'
import { Card } from 'antd'

export const Container = styled.div`
  .ant-tabs-nav-scroll {
    min-height: 46px;
  }

  .ant-form-extra {
    margin-top: -24px;
    margin-bottom: 0;
    color: #f5222d;
  }

  .has-error {
    .ant-checkbox {
      border: 1px solid #f5222d;
    }
  }
`

export const Actions = styled.div`
  text-align: right;
  white-space: nowrap;
  height: 16px;

  .ant-btn-link {
    color: #333;
    margin-left: 3px;
  }
`

export const Section = styled(Card)`
  .ant-card-head {
    border-bottom: none;

    .ant-card-extra {
      .ant-btn-link {
        color: unset;
      }
    }
  }

  &.ant-card-bordered + .ant-card-bordered {
    border-top: none !important;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  .ant-select-search__field__placeholder {
    color: rgba(0, 0, 0, 0.33) !important;
  }

  .ant-select-selection__placeholder {
    color: rgba(0, 0, 0, 0.33) !important;
  }

  *::placeholder {
    color: rgba(0, 0, 0, 0.33) !important;
  }

  textarea {
    resize: none;
  }
`
